import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout' 

export default async function PutProvider(data) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/meansOfPayment?countryUuid=' + data.country.value, {
            method: 'POST',
            headers: { 'Authorization' : unHashedJwt},
            data: {
                "description": data.description.trim(),
                "fiscalization_label": data.fiscalization_label.value,
                "allowed_invoice_types": data.allowed_invoice_types.trim(),
                "fiscalize": data.fiscalize,
                "send_receipt": data.send_receipt
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data)
    )
}